import { isDevelopment, isProduction, isTest } from "utils/environment";

const getMainUrl = () => {

  //return 'https://api.kkt-neva.ru';

  if(isProduction()) {
    return 'https://api.kkt-neva.ru';
  }
  else if(isDevelopment()) {
    return 'http://localhost:3001';
  }
  else if(isTest()) {
    return 'https://test.restart-kassa.ru';
  }
  return '';
};

const getDataUrl = () => {
  //return 'https://api.kkt-neva.ru/androidkassa/v1';

  if(isProduction()) {
    return 'https://api.kkt-neva.ru/androidkassa/v1';
  }
  else if(isDevelopment()) {
    //return 'http://localhost:3001/androidkassa/v0';
    return 'https://test.restart-kassa.ru/androidkassa/v1';
    
  }
  else if(isTest()) {
    return 'https://test.restart-kassa.ru/androidkassa/v1';
  }
  return '';
};

const getStaticUrl = () => {
  if(isProduction()) {
    return `${window.location.origin}`;
  }
  else if(isDevelopment()) {
    //return 'http://localhost:3001';
    //return `${window.location.origin}`;
    //return 'https://test.restart-kassa.ru';
    return 'https://android.restart-kassa.ru';
  }
  else if(isTest()) {
    return 'https://test.restart-kassa.ru';
    //return `${window.location.origin}`;
  }
  return '';
};

const getAuthUrl = () => {
  if(isProduction()) {
    return 'https://api.kkt-neva.ru/auth/v1';
  }
  return 'https://test.restart-kassa.ru/auth/v1';
};

const mainUrl = getMainUrl();
const dataUrl = getDataUrl();
const staticUrl = getStaticUrl();
const authUrl = getAuthUrl();

export {
  mainUrl,
  dataUrl,
  staticUrl,
  authUrl
};